import { ZonedDateTimeFactory } from '@csp/csp-common-date-util';
import { Maybe, UserMetrics } from '@csp/csp-common-model';
import { MetricsV1 } from '@csp/dmdp-api-user-dto';

const fromMetricsV1 = (metrics: Maybe<MetricsV1>): UserMetrics => ({
  heightMetres: metrics?.heightMetres,
  weightKg: metrics?.weightKg,
  createdAt: metrics?.createdAt
    ? ZonedDateTimeFactory.fromZonedDateTimeString(metrics.createdAt)
    : ZonedDateTimeFactory.fromUnixTimeMillis(0),
  createdBy: metrics?.createdBy,
  previousUserMetrics: (metrics?.previousMetrics ?? []).map(previousMetric => ({
    heightMetres: previousMetric.heightMetres,
    weightKg: previousMetric.weightKg,
    createdAt: previousMetric.createdAt
      ? ZonedDateTimeFactory.fromZonedDateTimeString(previousMetric.createdAt)
      : ZonedDateTimeFactory.fromUnixTimeMillis(0),
    createdBy: previousMetric.createdBy,
  })),
});

export const UserMetricsMapper = {
  fromMetricsV1,
};
